// extracted by mini-css-extract-plugin
export default {"signinWrapper":"Signin_signinWrapper__n-blJ","scrOne":"Signin_scrOne__qLvoB","scrTwo":"Signin_scrTwo__Rl3WO","signinBtn":"Signin_signinBtn__vPXMi"};